export default __webpack_public_path__ + "static/media/tutrial2.c5979ba4.jpg";